function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "InfoNavigationDefaultBG",
  transform: "translate(4216.418 -5996.526)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_135",
  className: "background",
  "data-name": "Ellipse 135",
  cx: 32,
  cy: 32,
  r: 32,
  transform: "translate(-4216.418 5996.526)",
  fill: "#0f426e"
}), /*#__PURE__*/React.createElement("g", {
  id: "InfoNavigationDefault",
  className: "bell",
  transform: "translate(-6290.76 5547.414)",
  fill: "#f2f7fa"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M2114.872 483.71v-5.069a8.449 8.449 0 00-8.448-8.45 8.449 8.449 0 00-8.448 8.45v5.069a2.983 2.983 0 01-2.982 2.982v.8a2.982 2.982 0 002.982 2.982h16.9a2.983 2.983 0 002.982-2.982v-.8a2.983 2.983 0 01-2.984-2.982z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_27",
  "data-name": "Rectangle 27",
  d: "M2105.87 467.424h.944a1.883 1.883 0 011.883 1.883 1.882 1.882 0 01-1.883 1.882h-.944a1.882 1.882 0 01-1.883-1.882 1.883 1.883 0 011.883-1.883z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_220",
  "data-name": "Path 220",
  d: "M2102.223 492.313a4.352 4.352 0 008.24 0z"
})));

function SvgInfoBellRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBellRound);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij4KICA8ZyBpZD0iSW5mb05hdmlnYXRpb25EZWZhdWx0QkciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQyMTYuNDE4IC01OTk2LjUyNikiPgogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xMzUiIGNsYXNzPSJiYWNrZ3JvdW5kIiBkYXRhLW5hbWU9IkVsbGlwc2UgMTM1IiBjeD0iMzIiIGN5PSIzMiIgcj0iMzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MjE2LjQxOCA1OTk2LjUyNikiIGZpbGw9IiMwZjQyNmUiLz4KICAgIDxnIGlkPSJJbmZvTmF2aWdhdGlvbkRlZmF1bHQiIGNsYXNzPSJiZWxsIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjI5MC43NiA1NTQ3LjQxNCkiPgogICAgICA8cGF0aCBpZD0iUGF0aF8xMiIgZGF0YS1uYW1lPSJQYXRoIDEyIiBkPSJNMjExNC44NzIsNDgzLjcxdi01LjA2OWE4LjQ0OSw4LjQ0OSwwLDAsMC04LjQ0OC04LjQ1aDBhOC40NDksOC40NDksMCwwLDAtOC40NDgsOC40NWgwdjUuMDY5YTIuOTgzLDIuOTgzLDAsMCwxLTIuOTgyLDIuOTgyaDB2LjhhMi45ODIsMi45ODIsMCwwLDAsMi45ODIsMi45ODJoMTYuOWEyLjk4MywyLjk4MywwLDAsMCwyLjk4Mi0yLjk4MnYtLjhoMGEyLjk4MywyLjk4MywwLDAsMS0yLjk4NC0yLjk4MloiIGZpbGw9IiNmMmY3ZmEiLz4KICAgICAgPHBhdGggaWQ9IlJlY3RhbmdsZV8yNyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMjciIGQ9Ik0yMTA1Ljg3LDQ2Ny40MjRoLjk0NGExLjg4MywxLjg4MywwLDAsMSwxLjg4MywxLjg4M2gwYTEuODgyLDEuODgyLDAsMCwxLTEuODgzLDEuODgyaC0uOTQ0YTEuODgyLDEuODgyLDAsMCwxLTEuODgzLTEuODgyaDBBMS44ODMsMS44ODMsMCwwLDEsMjEwNS44Nyw0NjcuNDI0WiIgZmlsbD0iI2YyZjdmYSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF8yMjAiIGRhdGEtbmFtZT0iUGF0aCAyMjAiIGQ9Ik0yMTAyLjIyMyw0OTIuMzEzYTQuMzUyLDQuMzUyLDAsMCwwLDguMjQsMFoiIGZpbGw9IiNmMmY3ZmEiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };